import api from '../../plugins/api';

export const getTripartiteContract = (dealId) => {
  return api.get(`/api/crm/deals/tripartiteContract?dealId=${dealId}`);
};

export const saveTripartiteContract = (payload) => {
  return api.post('/api/crm/deals/tripartiteContract', payload);
};

export const setTripartiteFlow = (payload) => {
  return api.post('/api/crm/deals/tripartiteContract/flow', payload);
};

export const sendTripartiteEcpSms = (payload) => {
  return api.post('/api/crm/deals/tripartiteContract/ecpSms', payload);
};

export const resetTripartiteEcp = (payload) => {
  return api.post('/api/crm/deals/tripartiteContract/ecpReset', payload);
};

export const resetTripartiteContract = (payload) => {
  return api.post('/api/crm/deals/tripartiteContract/reset', payload);
};
